import axios from "axios";
import { t } from "i18next";
import { API_URL, ENV } from "../settings";
import { storage } from "../utils/Storage";

const mode: "cors" | "navigate" | "no-cors" | "same-origin" | undefined = "cors";
const credentials: "same-origin" | "include" | "omit" | undefined = "same-origin";


let config: any = {
  headers: {
    "content-type": "multipart/form-data"
  },
};

if (ENV === "staging") {
  config.headers["Authorization"] = "Basic ZXZlbnRpYWxzOnczYjFuNHIhQCM=";
  config.credentials = credentials;
  config.mode = mode;
}

class SubscribeApi {
  axios;

  constructor() {
    this.axios = axios.create();
  }

  async guessUserInfo(email: string, userName: string, slug: string, type: "talk" | "group" | "event" | "course") {

    const formData = new FormData();
    formData.append("email", email);
    
    try{
      
      const response = await axios.post(
        `${API_URL}/${userName}/${type === "talk" ? "" : (type+'s/')}${slug}/guess-user-info/`,
        formData,
        config
      );

      return response;

    }catch(err: any){
      let errorMessage;

      if (err.response) {
        errorMessage = err.response;
      } else {
        errorMessage = t('dashboard.unexpectedError');
      }

      return errorMessage;
    }
  }

  async subscribe(userEmail: string, userName: string, slug: string, values: any, type: "talk" | "group" | "event" | "course") {
    
    let formData = new FormData();
    Object.keys(values).forEach((key) => {
      if(key !== 'email')
        formData.append(key, values[key])
    });

    formData.append("custom_var", "");
    formData.append("playlist", "");
    formData.append("email", userEmail);
    
    try {

      const response = await this.axios.post(
        `${API_URL}/${userName}/${type === "talk" ? "" : (type+'s/')}${slug}/subscribe/`,
        formData,
        config
      );

      if(response.status === 200){
        storage.set(`is_subscribed_${userName}_${type}_${slug}`,  userEmail);
        return response;
      }
      
    } catch(err:any){

      let errorMessage;

      if (err.response) {
        errorMessage = err.response;
      } else {
        errorMessage = t('dashboard.unexpectedError');
      }

      return errorMessage;
    }
  }

  async hasPendingPayment(type: "group" | "event" | "course" | "talk", slug: string, username: string): Promise<boolean> {

    try {
      config.headers = {
        "content-type": "application/json",
      };

      const response = await axios.get(`${API_URL}/${username}/${type === "talk" ? "" : type}${slug}/has-pending-payment/`, config);
  
      return response.data.has_pending_payment;

    } catch (err: any) {
      let errorMessage;

      if ("message" in err.response.data) {
        errorMessage = err.response.data.message;
      } else {
        errorMessage = t('dashboard.unexpectedError');
      }

      return errorMessage;
    }

  }

} 



export const subscribeApi = new SubscribeApi();
